import { render, staticRenderFns } from "./ProductLink.vue?vue&type=template&id=257c8032&scoped=true"
import script from "./ProductLink.vue?vue&type=script&lang=js"
export * from "./ProductLink.vue?vue&type=script&lang=js"
import style0 from "./ProductLink.vue?vue&type=style&index=0&id=257c8032&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257c8032",
  null
  
)

export default component.exports